import React from 'react';
import authBackground from '../../assets/images/auth-background.png';

interface AuthWrapperProps {
  children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
  return (
    <div className="h-screen flex bg-white">
      {/* Left Section - Background Image */}
      <div className="hidden lg:block lg:w-1/4 max-w-96 relative overflow-hidden">
        <img
          src={authBackground}
          alt="Auth Background"
          className="w-full h-full object-fill"
        />
      </div>

      {/* Right Section - Content */}
      <div className="flex-1 lg:w-2/3 flex flex-col">
        <div className="flex-1 flex items-center justify-center px-6 py-6">
          {children}
        </div>
        {/* Footer */}
        <div className="text-center py-6">
          <p className="text-gray-500 text-sm">
            All rights reserved © 2024 - 2025 YAD plus®.
          </p>
        </div>
      </div>
    </div>
  );
}
